// *** Allows to overwriteCustomeAssignments chart opts and colors and ... ***
//
import { CUSTOM_CHART_COLORS, CUSTOM_CHART_OPTS } from './colors'
import { overwriteCustomAssignments } from './custom_assignments'

export function overwriteColors() {
  var opts = {
    watermark: false
  }

  var colors = {
    primary: '#9DBF26',
    primaryDt: '#9DBF26',
    colormaps: {
      fromGridToPrimary: [
        '#CD5A4B',
        '#C76546',
        '#C27042',
        '#BD7B3E',
        '#B7863A',
        '#B29236',
        '#AD9D32',
        '#AD9D32',
        '#A7A82E',
        '#A2B32A',
        '#9DBF26'
      ],
      fromGridToPrimaryDt: [
        '#CD5A4B',
        '#C76546',
        '#C27042',
        '#BD7B3E',
        '#B7863A',
        '#B29236',
        '#AD9D32',
        '#AD9D32',
        '#A7A82E',
        '#A2B32A',
        '#9DBF26'
      ]
    },
    dashboard: {
      toGrid: '#ebc823',
      toGridDt: '#ebc823',
      fromGrid: '#cd5a4b',
      fromGridDt: '#cd5a4b'
    },
    battery: {
      con: ['#9dc900', '#b9cf66', '#d2e1a5'],
      gen: ['#328c46', '#00de73', '#aad7a0']
    },
    chp: {
      con: ['#735f05', '#afa064'],
      gen: ['#a07d0f', '#c8af73']
    },
    wallbox: {
      con: ['#c80087', '#d169aa', '#e1a0c8']
    },
    fuelcell: {
      con: ['#5f968c', '#96c8be'],
      gen: ['#a0d2a5', '#d2f5d2']
    },
    generic: {
      // user colors
      con: ['#73b4a0', '#a0d7be', '#c8e6dc'],
      // pv colors
      gen: ['#faf514', '#fffa96', '#f0eba5']
    },
    grid: {
      // feed-in
      con: ['#ebc823', '#ffaf00', '#e6d76e'],
      // delivery
      gen: ['#cd5a4b', '#dca08c', '#ebc3af']
    },
    heatingelement: {
      con: ['#676767', '#a4a4a4', '#d2d2d2'],
      gen: []
    },
    heatpump: {
      con: ['#780f87', '#aa64c8', '#aa82be']
    },
    pv: {
      gen: ['#ffff00', '#ffdc00', '#eeee00', '#d78723', '#e1b469', '#f0d7aa']
    },
    user: {
      con: ['#73b4a0', '#a0d7be', '#c8e6dc']
    },
    wind: {
      con: ['#3250aa', '#697dbe', '#a0afdc'],
      gen: ['#4691d2', '#a0bee6', '#bed2fa']
    }
  }

  overwriteCustomAssignments(opts, CUSTOM_CHART_OPTS)
  overwriteCustomAssignments(colors, CUSTOM_CHART_COLORS)
}
